module.exports = __webpack_public_path__ + "img/reponse-negative.a202323.png";